import { getSafeValue } from './safe-value';
import { json2html } from '../html2json';

export function jsonToHtml(val: string): string {
  if (!val) {
    throw 'Json value must be defined!';
  }

  try {
    const json = JSON.parse(val);
    const html = json2html(json);
    return getSafeValue(html);
  } catch (error) {
    console.error('Error parsing JSON in jsonToHtml:', error);
    return '';
  }
}
